const comments = [
  {
    name: '夜雨声烦',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20female%20avatar%20portrait%2C%20soft%20warm%20colors%2C%20simple%20minimalist%20design%2C%20gentle%20expression%2C%20clean%20background&width=80&height=80&seq=avatar-comment-01&orientation=squarish',
    time: '2小时前',
    comic: '《咒术回战》',
    text: '妖精动漫网的下拉式阅读太方便了！追咒术回战一口气看了50话完全不累，画质也高清。推荐给所有漫友！',
    likes: 328,
  },
  {
    name: '风之旅人',
    avatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20male%20avatar%20portrait%2C%20warm%20earthy%20tones%2C%20simple%20minimalist%20design%2C%20calm%20expression%2C%20clean%20background&width=80&height=80&seq=avatar-comment-02&orientation=squarish',
    time: '5小时前',
    comic: '《海贼王》',
    text: '更新速度真的快，每周都能第一时间看到最新话。收藏功能也好用，追的十几部漫画管理得明明白白。',
    likes: 256,
  },
  {
    name: '樱花飘落',
    avatar: 'https://readdy.ai/api/search-image?query=Soft%20anime%20style%20female%20avatar%20portrait%2C%20pink%20warm%20tones%2C%20simple%20minimalist%20design%2C%20sweet%20expression%2C%20clean%20background&width=80&height=80&seq=avatar-comment-03&orientation=squarish',
    time: '昨天',
    comic: '《间谍过家家》',
    text: '界面清爽没有乱七八糟的广告，体验特别好。番外篇更新也很快，安妮亚太可爱了每天都要来看！',
    likes: 189,
  },
  {
    name: '深海鲸鱼',
    avatar: 'https://readdy.ai/api/search-image?query=Mysterious%20anime%20style%20male%20avatar%20portrait%2C%20cool%20blue-gray%20tones%2C%20simple%20minimalist%20design%2C%20thoughtful%20expression%2C%20clean%20background&width=80&height=80&seq=avatar-comment-04&orientation=squarish',
    time: '2天前',
    comic: '《葬送的芙莉莲》',
    text: '找了好久才找到这么全的免费漫画网站，分类也很细致。冷门佳作也能搜到，收藏夹已经塞不下了！',
    likes: 412,
  },
  {
    name: '墨染青衣',
    avatar: 'https://readdy.ai/api/search-image?query=Elegant%20anime%20style%20female%20avatar%20portrait%2C%20warm%20autumn%20tones%2C%20simple%20minimalist%20design%2C%20gentle%20smile%2C%20clean%20background&width=80&height=80&seq=avatar-comment-05&orientation=squarish',
    time: '3天前',
    comic: '《坂本日常》',
    text: '手机端阅读体验真的绝了，通勤路上追漫太舒服了。书签功能也很贴心，下次继续读不用重新找位置。',
    likes: 167,
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-2 text-center">
          读者热评
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">百万漫友的真实声音</p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {comments.map((item, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-5 flex flex-col gap-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-sm text-foreground-900 truncate">{item.name}</div>
                  <div className="flex items-center gap-2 text-xs text-foreground-400">
                    <span>{item.time}</span>
                    <span>·</span>
                    <span className="text-primary-500 font-medium">{item.comic}</span>
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.text}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}